import { get, postText } from "../../components/hooks/apiFetch";

export const useSpeechToTextApi = () => {
    const submitSpeechRequest = async (audioBlob, identifier, fileName) => {
        try {
            const formData = new FormData();
            formData.append("audio", audioBlob, fileName);

            const url = `/api/MicrophoneTranscribe/${encodeURIComponent(identifier)}`;
            const text = await postText(url, formData);
            return text;
        } catch (error) {
            console.error('Ошибка преобразования речи в текст:', error);
            throw new Error(error.message || 'Ошибка при обработке аудио');
        }
    };

    const cancelSpeechRequest = async (identifier) => {
        try {
            const url = `/api/MicrophoneTranscribe/Cancel/${encodeURIComponent(identifier)}`;

            await get(url);
        } catch (error) {
            console.error('Ошибка при отмене обработки аудио', error);
            throw error;
        }
    };

    return { submitSpeechRequest, cancelSpeechRequest };
};